<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_news_intro')
}

const isOnNewsSection = computed(() => {
  return route.path.startsWith('/news')
})

const goToNews = () => {
  router.push('/news')
}
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/news.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.news.intro.hello') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.news.intro.keepUpToDate') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.news.intro.receiveReports') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info" class="hidden md:flex">
        {{ t('tutorial.news.intro.clickNewsDesktop') }}
      </AlertBox>
      <AlertBox type="info" class="md:hidden">
        {{ t('tutorial.news.intro.clickNewsMobile') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnNewsSection" @click="goToNews" class="mr-2">
        {{ t('tutorial.news.intro.goToNews') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('common.actions.continue') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>